import { render, staticRenderFns } from "./DialogMessage.vue?vue&type=template&id=5aee0cc2"
import script from "./DialogMessage.vue?vue&type=script&lang=js"
export * from "./DialogMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports